/**
 * @generated SignedSource<<85c7fd826fe030957a6913b92e2951af>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
import { FragmentRefs } from "relay-runtime";
export type appointmentStatusCell_appointment$data = {
  readonly completedAt: string | null;
  readonly id: string;
  readonly isCompleted: boolean;
  readonly lastMissedCallAt: string | null;
  readonly missedCallsCount: number;
  readonly patient: {
    readonly patientFileLock: {
      readonly lockedAt: string | null;
      readonly lockedBy: string | null;
    };
  };
  readonly status: AppointmentStatus;
  readonly takenBy: string | null;
  readonly " $fragmentType": "appointmentStatusCell_appointment";
};
export type appointmentStatusCell_appointment$key = {
  readonly " $data"?: appointmentStatusCell_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentStatusCell_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentStatusCell_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "missedCallsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMissedCallAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takenBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientFileLock",
          "kind": "LinkedField",
          "name": "patientFileLock",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedBy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "40e87e0a223723cdacdb021a13c9e0df";

export default node;
